import { getWorkspaceIdFromCurrentUrl } from '@/context/current-workspace';
import { AuditLogsPageContainer } from '@/features/audit-logs/components/AuditLogsPageContainer';

export const WorkspaceAuditLogs = () => {
  const workspaceId = getWorkspaceIdFromCurrentUrl();

  return (
    <AuditLogsPageContainer
      context="workspace"
      contextId={workspaceId}
      breadcrumbs={[
        { text: 'Workspace settings', href: `/workspaces/${workspaceId}/settings` },
        { text: 'Audit logs' },
      ]}
      pageTitle="Audit Logs"
      pageDescription="View audit logs for this workspace to track changes and activities."
      backUrlBase={`/workspaces/${workspaceId}/settings/audit-logs`}
      feedbackFeature="Workspace Audit Logs"
    />
  );
};
